import { render } from "./CreateOnboarding.vue?vue&type=template&id=34dc6642"
import script from "./CreateOnboarding.vue?vue&type=script&lang=js"
export * from "./CreateOnboarding.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__